export default "__VITE_ASSET__BZKejOoK__"